import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { transformSucessResponse, transformErrorResponse } from "../../utils/API/responseMiddleware";
import { encryptQueryString, transformRequest } from "../../utils/API/requestMiddleware"
import { customFetchBase } from '../../utils/API/fetchBaseQuery';


const bondAPI = createApi({
    reducerPath: 'bondAPI',
    baseQuery: customFetchBase,

    endpoints: (builder) => ({

        getCompanyBonds: builder.mutation({
            query: (details) => ({
                url: '/CompanyBond/GetCompanyBonds',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        addCompanyBond: builder.mutation({
            query: (details) => ({
                url: '/CompanyBond/AddCompanyBond',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateCompanyBond: builder.mutation({
            query: (details) => ({
                url: '/CompanyBond/UpdateCompanyBond',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        deleteCompanyBond: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/CompanyBond/DeleteCompanyBond/?id=${details}`),
                method: 'DELETE',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        downloadFile: builder.query({
            query: (details) => ({
                url: encryptQueryString(`/Common/DownloadFile?folderName=${details.folderName}&fileName=${details.fileName}`),
                method: 'GET',
                responseHandler: (response)=> response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
});

export const { useGetCompanyBondsMutation, useAddCompanyBondMutation, useUpdateCompanyBondMutation, useDeleteCompanyBondMutation, useLazyDownloadFileQuery, } = bondAPI;

export default bondAPI